var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-header'),_c('PageHeader',{attrs:{"title":"Contact Us"}}),_c('div',{staticClass:"container py-10"},[_c('div',{staticClass:"login-container max-w-md mx-auto"},[_c('div',{staticClass:"rounded-lg bg-gray-100 p-10"},[_c('ContactForm')],1)])]),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }